// extracted by mini-css-extract-plugin
export default {"button":"FavoriteRemoveButton_button__W6kFn"};